import {
  GET_CALCULATION_FAILED,
  GET_CALCULATION_REQUESTED,
  GET_CALCULATION_SUCCESS,
  QUICK_CALCULATION_RESET,
  SAVE_CALCULATION,
  NOT_SAVE_CALCULATION,
} from './actionTypes'

export const requestForCalculation = (payload) => ({
  type: GET_CALCULATION_REQUESTED,
  payload
})

export const requestForCalculationSuccess = payload => ({
  type: GET_CALCULATION_SUCCESS,
  payload,
})

export const requestForCalculationFailed = payload => ({
  type: GET_CALCULATION_FAILED,
  payload,
})

export const resetCalculations = (payload) => ({
  type: QUICK_CALCULATION_RESET,
  payload,
})

export const saveCalculations = (payload) => ({
  type: SAVE_CALCULATION,
  payload
})

export const notSaveCalculations = (payload) => ({
  type: NOT_SAVE_CALCULATION,
  payload
})

